import DrawIcon from "@mui/icons-material/Draw";
import { erasmusRequests } from "api/erasmusApi";
import { useNotify, useRecordContext, useRefresh } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { ErasmusRegularStudentStatus } from "utils/constants";

const SendForSignatureModal = ({ label = "Изпрати за подпис" }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();

  // Signing is the first transition of the process - only a Created application can be sent.
  if (record?.status !== ErasmusRegularStudentStatus.Created) return null;

  const handleConfirm = async () => {
    await dataProvider.customRequest(erasmusRequests.signIncomingStudentsRegular(record.id), null, "POST");
    refresh();
    notify("Успешно изпратено за подпис", { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent="Изпращане за подпис"
      message="Сигурни ли сте, че искате да изпратите заявката за подпис?"
      onConfirm={handleConfirm}
      startIcon={<DrawIcon />}
      titleButton={label}
      btnStyle={{
        width: "max-content",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
      }}
      variant="contained"
    />
  );
};

export default SendForSignatureModal;
